const MegaMenu = () => ({
  isOpen: false,

  open() {
    this.isOpen = true;
  },

  close() {
    this.isOpen = false;
  }
});

export default MegaMenu;
